var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGirlHead1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 530,
    height: 558,
    viewBox: "0 0 530 558",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Girl / Head / 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Hair",
    d: "M441.52 186.608C443.37 189.103 444.321 191.756 444.199 194.575C447.808 206.568 449.753 219.256 449.773 232.387C449.775 234.07 449.746 235.745 449.686 237.414L449.889 382.693L174.209 383.127L173.999 233.021L174.095 233.021C174.095 232.944 174.095 232.866 174.095 232.789C173.981 158.457 235.601 98.1107 311.729 97.9987C371.389 97.9125 422.253 134.847 441.52 186.608Z",
    fill: "#19141E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M334.038 368.302C334.038 368.302 308.176 369.066 297.154 363.044L332.664 385.34L334.038 368.302Z",
    fill: "#CF3E83"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Face color"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Face",
    d: "M278.465 277.562C293.252 276.375 384.304 266.908 434.356 210.854L434.601 210.92C434.601 210.92 435.819 334.3 391.681 359.64C377.941 367.52 354.479 369.48 334.041 368.3L329.341 426.38L262.601 398.92C262.601 398.92 269.001 334.84 271.781 310.24C258.361 298.06 235.521 292.42 235.479 271.74C235.461 264.6 239.639 252.2 255.079 252.18C275.819 252.16 272.861 276.98 272.861 276.98C274.727 277.707 276.597 277.876 278.465 277.562Z",
    fill: "#5E93D1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill 11",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M390.257 276.939L405.057 312.819L387.885 312.475L390.257 276.939Z",
    fill: "#2437A8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 13",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M374.499 278.496C374.129 285.664 369.915 291.248 365.083 290.97C360.251 290.692 356.633 284.656 357.003 277.488C357.371 270.32 361.587 264.734 366.419 265.012C371.249 265.292 374.869 271.328 374.499 278.496Z",
    fill: "#0D0B6D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 15",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M419.872 277.351C419.504 284.519 415.288 290.103 410.456 289.825C405.626 289.547 402.006 283.511 402.376 276.343C402.746 269.175 406.96 263.589 411.792 263.869C416.624 264.147 420.242 270.183 419.872 277.351Z",
    fill: "#0D0B6D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 17",
    d: "M383.673 329.662C383.673 329.662 372.485 333.272 361.275 320.808",
    stroke: "#1C295E",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 19",
    opacity: 0.395159,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M333.996 368.301C333.996 368.301 308.134 369.065 297.112 363.045L332.622 385.339L333.996 368.301Z",
    fill: "black"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGirlHead1);
export default __webpack_public_path__ + "static/media/Girl-Head-1.5e1a6e20.svg";
export { ForwardRef as ReactComponent };